import * as ActionTypes from 'actions';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  events: {},
  addEvent: { isLoading: false, conflicts: [] },
};

function resetState(newState, event, isLoading) {
  const reset = { ...newState };
  if (event.id) {
    reset.events[event.id] = { isLoading, conflicts: [] };
  } else {
    reset.addEvent = { isLoading, conflicts: [] };
  }
  return reset;
}

export default function(state = initialState, action = {}) {
  const { type, response, error, event } = action;

  switch (type) {
  case ActionTypes.EVENT_CONFLICT_CHECK_REQUEST: {
    return resetState({ ...state }, event, true);
  }

  case ActionTypes.EVENT_CONFLICT_CHECK_SUCCESS: {
    const newState = { ...state };
    if (event.id) {
      newState.events[event.id] = { isLoading: false, ...response };
    } else {
      newState.addEvent = { isLoading: false, ...response };
    }
    return newState;
  }

  case ActionTypes.EVENT_CONFLICT_CHECK_FAILURE: {
    console.error('Error loading EVENT_CONFLICT_CHECK', error);
    return resetState({ ...state }, event, false);
  }

  case ActionTypes.EVENT_CONFLICT_CHECK_RESET: {
    return resetState({ ...state }, event, false);
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/eventConflictChecks.js